// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The search provider registry token.
 */
export const ISearchProviderRegistry = new Token('@jupyterlab/documentsearch:ISearchProviderRegistry');
//# sourceMappingURL=tokens.js.map